var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.herSettings.enable)?_c('div',[_c('b-button',{staticClass:"d-flex ml-auto mr-auto mt-3 w-100 justify-content-center btn-single-cta",class:_vm.herSettings.class,style:(_vm.herSettings.style),attrs:{"disabled":!_vm.enableButton},on:{"click":_vm.downloadReport}},[_vm._v(" "+_vm._s(_vm.herSettings.text)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }